import { Toast } from '@src/common/components/Toast';
import type { ToastLevel } from '@src/common/components/ToastLevel';
import { SnackbarProvider } from 'notistack';
import type { PropsWithChildren } from 'react';

declare module 'notistack' {
  interface VariantOverrides {
    toast: {
      title?: string;
      message: string | React.ReactNode;
      severity: ToastLevel;
    };
  }
}

export const DEFAULT_TOAST_DELAY = 4000;

export const ToastProvider = ({ children }: PropsWithChildren) => {
  return (
    <SnackbarProvider
      Components={{ toast: Toast }}
      maxSnack={5}
      autoHideDuration={DEFAULT_TOAST_DELAY}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      {children}
    </SnackbarProvider>
  );
};
